<template>
  <div class="search-box-two-input" :class="{ 'type-2': type == 2 }">
    <div class="input-wrapper">
      <Icon-location-outline v-if="type == 2" class="text-[20px] text-primary-1 !mb-0 me-2.5 min-w-5" />
      <icon-search-icon v-else class="text-[20px] text-gray-1 !mb-0 me-2.5 min-w-5" />
      <input
        v-model="searchedText"
        type="text"
        name="search-text"
        class="search-input"
        autocomplete="off"
        :placeholder="type == 2 ? t('whichCity') : t('index.search.whereYouGo')"
        @focus="inputFocused"
      />
      <BaseButton
        v-if="type != 2"
        class="!px-5 md:!px-12 !rounded-[30px]"
        type="primary"
        :height="48"
        :label="t('search')"
      />
    </div>
    <BaseButton
      v-if="type == 2"
      class="w-full move-icon-on-hover !rounded-[100px]"
      type="primary"
      :label="t('search')"
      :height="!isMobile ? 54 : 45"
      :appendIcon="'icon-arrow-u'"
      :font="'md:text-link-1 text-mobile-link-1'"
      :iconClass="'rtl:rotate-180 text-white text-[24px] !mb-0 !ms-2.5'"
    />
  </div>
</template>

<script setup lang="ts">
const { t } = useI18n();

const searchedText = ref<string>("");
const emit = defineEmits(["text", "focused"]);

defineProps({
  type: { type: Number, default: 1 },
});

const isMobile = ref(false);

onMounted(() => {
  isMobile.value = window.innerWidth <= 768;
});

watch(searchedText, (val) => {
  emit("text", val);
});

const inputFocused = () => {
  emit("focused");
};
</script>

<style scoped lang="scss">
.search-box-two-input {
  @apply flex items-center justify-center;
}
.input-wrapper {
  @apply w-full flex items-center border border-[#EDF2F4] bg-white shadow-2 rounded-[40px] ps-5 pe-1;
}

.search-box-two-input.type-2 {
  @apply max-md:flex-col px-2.5 md:px-5 py-5 md:py-[18px] bg-gray-4 border border-gray-3 rounded-[20px] md:rounded-[50px] gap-2 md:gap-4 md:w-[613px];
  @media screen and (min-width: 768px) {
    box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.3);
  }
}
.search-box-two-input.type-2 .input-wrapper {
  @apply border border-gray-3 h-[45px] md:h-[54px] shadow-none md:w-[363px] md:min-w-[363px];
}
.search-box-two-input.type-2 .input-wrapper .search-input {
  @apply text-mobile-link-1 md:text-link-1;
  font-family: 'Roboto' !important
}
.search-input {
  @apply h-14 w-full border-none bg-transparent;

  &:focus {
    outline: none;
  }
  //placholder
  &::placeholder {
    @apply text-gray-1 md:text-paragraph-2 text-mobile-paragraph-2;
  }
}
</style>
